import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {forgotPassword} from '../actions';

class ForgotPasswordPage extends React.Component
{
  constructor(props)
  {
    super(props);

    this.state = {
      username: '',
      sent: false
    };
  }

  handleUsernameChanged = (username) => {
    this.setState({username: username});
  }

  handleSendPassword = () => {
    this.props.actions.forgotPassword(this.state.username);
    this.setState({username: ''});
    this.setState({sent: true});
  }

  render()
  {
    return (
      <div id="login-form-container">
        <div className="container login">
          <form className="form-login">
            <div className="logo-login">
              <Link to="/">{I18n.t('pet_data')}</Link>
            </div>

            {this.state.sent === false && <div>
              {I18n.t('RESET_PASSWORD_HEADER')}
              <label htmlFor="email" className="sr-only">{I18n.t('EMAIL_ADDRESS')}</label>
              <input name="email" 
                      className="form-control" 
                      placeholder={I18n.t('EMAIL_ADDRESS')} 
                      value={this.state.username} 
                      onChange={(e) => {this.handleUsernameChanged(e.target.value);}}
              />
              
              <button type="button" className="btn btn-login" onClick={this.handleSendPassword}>{I18n.t('SEND_PASSWORD')}</button>
              <div className="no-account">
                <Link to="/labels">{I18n.t('RESET_PASSWORD_BACK')}</Link>
              </div>
            </div>}

            {this.state.sent === true && <div>
              <div>{I18n.t('RESET_PASSWORD_CONFIRMATION')}</div>
              <div className="no-account">
                <Link to="/labels">{I18n.t('RESET_PASSWORD_BACK')}</Link>
              </div>
              
            </div>}
          </form>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({forgotPassword}, dispatch)
  };
}

ForgotPasswordPage.propTypes = {
  actions: PropTypes.object.isRequired
};

export default connect(null, mapDispatchToProps)(ForgotPasswordPage);


/** WEBPACK FOOTER **
 ** ./src/modules/customer/components/ForgotPasswordPage.js
 **/